<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  src?: string
  showEdit?: boolean
  editIconClass?: string
  editIconSize?: number
}
const props = withDefaults(defineProps<Props>(), {
  editIconClass: 'tw-bottom-2 tw-right-2 tw-p-2',
  editIconSize: 20,
})

const defaultAvatar = '/images/profile/xpress/default_avatar.png'
const imageSrc = ref(props.src || defaultAvatar)

const handleImageError = () => {
  imageSrc.value = defaultAvatar
}
</script>

<template>
  <div class="tw-relative tw-w-fit">
    <div class="tw-bg-white tw-rounded-full tw-p-1">
      <img
        :src="imageSrc"
        alt="Profile Character"
        class="tw-w-28 tw-h-28 tw-object-cover tw-rounded-full"
        @error="handleImageError"
      />
    </div>
    <!-- Edit Icon -->
    <div
      v-if="showEdit"
      :class="['tw-absolute tw-bg-white tw-rounded-full tw-shadow-md', editIconClass]"
      style="border: 3px solid #ffc0cb"
    >
      <v-icon color="pink" :size="editIconSize">mdi-camera-plus</v-icon>
    </div>
  </div>
</template>
